import { Injectable } from '@angular/core';
import {AuthHttp} from '../../user/services/auth/http/auth-http.service';
import {environment} from '../../../../environments/environment';

@Injectable()
export class ServiceReportService {

    protected route = 'servicereport';
    constructor(private http: AuthHttp) { }


    public runReport(filters, columns, rows) {
        return this.http
          .get(`${environment.baseUrl}${this.route}`
            + `?token=${this.http.getTokenBearer()}`
            + `&filters=${JSON.stringify(filters)}`
            + `&columns=${JSON.stringify(columns)}`
            + `&rows=${JSON.stringify(rows)}`).map(r => r.text()).toPromise();
    }

    public downloadReport(fileName) {
      window.location.href = encodeURI(`${environment.baseUrl}${this.route}/get?token=${this.http.getTokenBearer()}&file=${fileName}`);
    }
}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/servicereport/services/service-report.service.ts